export default {"src":"/_next/static/media/free-mask.3ef36903.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};